import { ActivityBookingTokensService } from '@libs/search-service-smart-search';
import type {
  ActivityToBook,
  BusinessCriteria,
} from '@libs/trip-planner-interfaces';
import { redirect } from '@libs/utils';

import { ApiQuery } from './shared/apiQuery';

type BasketToken = string;

interface BasketData {
  ItemTokens: string[][];
  SalesChannels: string[];
}

export class BasketService {
  private query: ApiQuery;
  private searchService = new ActivityBookingTokensService();

  public constructor() {
    this.query = new ApiQuery();
  }

  public addToBasket(token: BasketToken): Promise<void> {
    return this.addTokensToBasket([[token]]);
  }

  public async addTokensToBasket(tokens: [BasketToken][]): Promise<void> {
    const addToBasketUrl = 'mvc/Basket/TryClearAndAdd';
    const basketData: BasketData = {
      ItemTokens: tokens,
      SalesChannels: ['planner'],
    };

    try {
      await this.query.post(addToBasketUrl, basketData);
    } catch (error) {
      throw new Error(
        `Proceed to checkout error. ${JSON.stringify({ error, basketData })}`
      );
    }
  }

  public goToCheckoutPage(): void {
    const endPointUrl = this.query.getEndpointUrl(
      'booking/checkout.aspx?sc=planner'
    );
    //NOTE: Adding this so we will redirect back to the overview view from the checkout
    const returnUrl = `${window.location.href}&landing=overview`;
    history.replaceState({}, '', returnUrl);

    redirect(endPointUrl);
  }

  public async getActivityBookingTokens(
    activitiesToBook: ActivityToBook[],
    businessCriteria: BusinessCriteria
  ): Promise<BasketToken[]> {
    return this.searchService.getTokens(activitiesToBook, businessCriteria);
  }
}
